import React, { useState } from 'react';

const LazyImage = ({ src, alt, className, onClick, style }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [isError, setIsError] = useState(false);
    
    // حماية شاملة من undefined و null
    const safeSrc = src && typeof src === 'string' && src.trim() !== '' ? src : null;
    
    if (!safeSrc) {
        return (
            <div className={`${className || ''} bg-gray-200 flex items-center justify-center`} style={style}>
                <span className="text-gray-500 text-sm">لا توجد صورة</span>
            </div>
        );
    }
    
    return (
        <div className={`relative ${className || ''}`} style={style}>
            {!isLoaded && !isError && (
                <div className="absolute inset-0 bg-gray-200 animate-pulse rounded-lg flex items-center justify-center">
                    <div className="text-gray-500 text-sm">جاري التحميل...</div>
                </div>
            )}
            
            <img
                src={safeSrc}
                alt={alt || ''}
                className={`w-full h-full object-contain rounded-lg transition-opacity duration-300 ${
                    isLoaded ? 'opacity-100' : 'opacity-0'
                } ${onClick ? 'cursor-pointer' : ''}`}
                onLoad={() => setIsLoaded(true)}
                onError={() => setIsError(true)}
                onClick={onClick}
                loading="lazy"
            />
            
            {isError && (
                <div className="absolute inset-0 bg-gray-300 flex items-center justify-center rounded-lg">
                    <span className="text-gray-500 text-sm">فشل تحميل الصورة</span>
                </div>
            )}
        </div>
    );
};

export default LazyImage;